import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import keycode from 'keycode';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import {DatePicker} from 'material-ui-pickers';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import InputAdornment from '@material-ui/core/InputAdornment';  
import Input from '@material-ui/core/Input';  

import {BASE_URL_JAVAZ_API} from 'constants/ActionTypes';

const apiUrlHeader = BASE_URL_JAVAZ_API;
const apiUrl = apiUrlHeader+"/vehicle-license";
const masterTitleLower = "license vehicle";
const masterTitleCapital = "License Vehicle";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 20

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
      flex: {
        flex: 1,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

const periodsNotification = [
  {
    value: 'day',
    label: 'Day',
  },
  {
    value: 'week',
    label: 'Week',
  },
  {
    value: 'month',
    label: 'Month',
  },
];

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

const MySnackbarContentWrapper = withStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    iconSnack: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }))(MySnackbarContent);

class DialogForm extends React.Component {

    //handle company dd add
    callbackCompany = ({id}) => {
        this.setState({companyIdForm: id})
    };
    // end function ==============================================================================

    async componentDidMount() {
        this.props.showDialog(this.showDialog);
        
    };

    async componentDidUpdate() {
        
        if(this.state.isParentClick == true){
            if(this.props.idData == 0 ){
                this.setState({
                    openDialog: true,
                    action: "tambah",
                    
                    companyIdForm:companyIdGlobal,
                    thresholdForm: "0",
                    thresholdDangerForm: "0",
                    licenseNameForm: "",
                    periodeNotificationForm: "day",
                    valuePeriodeNotificationForm: "0"

                })
            }else{
                this.setState({action: "ubah"});
                this.handleClickOpenEdit(this.props.idData);
            }
            this.setState({ isParentClick : false });
        }
        
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            openDialog: false,
            isParentClick: false,
            action: "tambah",

            //snackbar state
            openSnackSuccess: false,
            openSnackErr: false,
            messageSnackBar:"",

            idData:0,

            //FORM================================================
            companyIdForm:companyIdGlobal,
            thresholdForm: "",
            thresholdDangerForm: "",
            licenseNameForm: "",
            periodeNotificationForm: "",
            valuePeriodeNotificationForm: "",
            loading: false
        };

        this.showDialog = this.showDialog.bind(this);
    };

    showDialog() {
        
        this.setState({ isParentClick : true });
    };

    // logic new ================================================================================
    handleClose = async(param) => {
        if(param === 'batal'){
            
            this.setState({ idData:0, openDialog: false });
            this.props.closeDialog(); 
        } else if (param === 'tambah') {
          const {thresholdDangerForm, thresholdForm} = this.state
            // console.log("danger", thresholdDangerForm)
            // console.log("warning", thresholdForm)
            if(parseInt(thresholdDangerForm) >= parseInt(thresholdForm)){
                NotificationManager.error("Treshold Almost must be lower than Treshold Warning", 'Error message')
            } else {
                this.setState({idData:0, loading: true})
        
                const data = {
                    "license_name" : this.state.licenseNameForm,
                    "company" : parseInt(this.state.companyIdForm),
                    "threshold": parseInt(this.state.thresholdForm),
                    "threshold_danger": parseInt(this.state.thresholdDangerForm),
                    "periode_notification": this.state.periodeNotificationForm,
                    "value_periode_notification": parseInt(this.state.valuePeriodeNotificationForm)
                }
                // console.log("data payload", data)
                let obj = JSON.stringify(data);
                
                const result = await axios.post(apiUrl+'/new', obj, config)
                                    .then(res => res)
                                    .catch((error) => error.response )
                // console.log("response api", result)
                if(result.data.code === 201){
                    NotificationManager.success("Success insert "+masterTitleLower+" data", 'Success message') 
                    this.setState({ openDialog: false, loading: false });
                    this.props.closeDialog(result.data); 
                }else{
                    this.setState({loading: false})
                    NotificationManager.error("Failed insert "+masterTitleLower+" data : "+result.data.message, 'Error message')
                }
            }
                 
        } else if (param === 'ubah') {
            if(this.state.thresholdDangerForm >= this.state.thresholdForm){
                NotificationManager.error("Treshold Almost must be lower than Treshold Warning", 'Error message')
            } else {
                this.setState({loading: true})
                const {idData} = this.state
            
                const data = {
                    "license_name" : this.state.licenseNameForm,
                    "company" : parseInt(this.state.companyIdForm),
                    "threshold": parseInt(this.state.thresholdForm),
                    "threshold_danger": parseInt(this.state.thresholdDangerForm),
                    "periode_notification": this.state.periodeNotificationForm,
                    "value_periode_notification": parseInt(this.state.valuePeriodeNotificationForm)
                }
                let obj = JSON.stringify(data);    
                const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
                                    .then(res => res)
                                    .catch((error) => error.response )
                if(result.data.code === 200){
                    
                    NotificationManager.success("Success update "+masterTitleLower+" data", 'Success message') 
                    
                    this.setState({ openDialog: false, loading: false });
                    this.props.closeDialog(result.data);  
                }else{
                    this.setState({loading: false})
                    NotificationManager.error("Failed update "+masterTitleLower+" data : "+result.data.message, 'Error message')
                    
                }
            }
        }
        
    };


    //logic open edit ===========================================================================
    handleClickOpenEdit = async(id) => {
        this.setState({openDialog: true, idData:id})

        const result = await axios.get(`${apiUrl}/${id}`, config)
                            .then(res => res)
                            .catch((error) => error.response )
                          
        if(result.data.code === 200){
         
            this.setState({
                companyIdForm:result.data.data.company,
                thresholdForm: result.data.data.threshold,
                thresholdDangerForm: result.data.data.threshold_danger,
                licenseNameForm:result.data.data.license_name,
                periodeNotificationForm: result.data.data.periode_notification,
                valuePeriodeNotificationForm: result.data.data.value_periode_notification
            })      
        }
                         
    };

    // end function sales =================================================================
    
    render() {
        const {classes} = this.props
        const {loading} = this.state

        return (
            <div>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackSuccess}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackSuccess: false })}
                >
                  <MySnackbarContentWrapper
                    onClose={()=> this.setState({ openSnackSuccess: false })}
                    variant="success"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackErr}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackErr: false })}
                >
                  <MySnackbarContentWrapper
                  onClose={()=> this.setState({ openSnackErr: false })}
                    variant="error"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>

                <NotificationContainer/>
                    
                <Dialog
                fullScreen
                open={this.state.openDialog}
                onClose={() => this.handleClose('batal')}
                TransitionComponent={Transition}
                >
                <AppBar className="sticky-container">
                    <Toolbar>
                    <Typography variant="h6" color="inherit" className={classes.flex}>
                        {masterTitleCapital}
                    </Typography>
                    <Button 
						variant="raised" 
						disabled={loading}
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						className="bg-white text-black" 
						onClick={() => { if(!loading) this.handleClose('batal')}}
					>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button 
						variant="raised" 
						color="primary" 
						disabled={loading} 
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						onClick={() => { if(!loading) this.handleClose(this.state.action) }}
					>		 
						{loading ? (
							<CircularProgress
								className="text-white"
								size={24}
							/>						  
						) : this.state.action}
                    </Button>
                    </Toolbar>
                </AppBar>
                
                <div className="app-wrapper" style={{marginTop: '12%'}}>
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Grid item xs={12}>
                                <InputVirtual 
                                    label="Perusahaan"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={apiUrlHeader+"/company/search"}
                                    getData={this.callbackCompany}
                                    setData={[{name:"id",value:this.state.companyIdForm.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormCompany"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Lisensi"
                                  // className={classes.textField}
                                  value={this.state.licenseNameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({licenseNameForm: e.target.value})}

                                />
                                
                            </Grid>
                            
                            
                        </Grid>

                        <Grid item xs={6}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                  <TextField
                                    label="Threshold Warning"
                                    // className={classes.textField}
                                    value={this.state.thresholdForm}
                                    fullWidth
                                    type="number"
                                    onChange={(e) => this.setState({thresholdForm: e.target.value})}
                                    endAdornment={<InputAdornment position="end">days</InputAdornment>}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    label="Threshold Almost"
                                    // className={classes.textField}
                                    value={this.state.thresholdDangerForm}
                                    fullWidth
                                    type="number"
                                    onChange={(e) => this.setState({thresholdDangerForm: e.target.value})}
                                    endAdornment={<InputAdornment position="end">days</InputAdornment>}
                                  />
                                </Grid>
                            </Grid>
                            
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <TextField
                                      label="Value"
                                      // className={classes.textField}
                                      value={this.state.valuePeriodeNotificationForm}
                                      fullWidth
                                      type="number"
                                      onChange={(e) => this.setState({valuePeriodeNotificationForm: e.target.value})}
    
                                    />
                                    
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                      select
                                      fullWidth
                                      label="Periods"
                                      // className={classes.textField}
                                      value={this.state.periodeNotificationForm}
                                      onChange={(e) => this.setState({periodeNotificationForm: e.target.value})}
                                      SelectProps={{
                                        MenuProps: {
                                          className: classes.menu,
                                        },
                                      }}
    
                                    >
                                      {periodsNotification.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                          {option.label}
                                        </MenuItem>
                                      ))}
                                    </TextField>



                                </Grid>
                            </Grid>

                        </Grid>

                        
                        
                    </Grid>
                </div>
                </Dialog>
                
                    
               
            </div>
        );
    }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterVehicleLicense/DialogForm.js